import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c5f9c44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widget" }
const _hoisted_2 = { class: "center widget__spinner" }
const _hoisted_3 = ["src"]

import { computed } from 'vue';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServicesAndChecksWidget',
  setup(__props) {

const widgetUrl = computed(() => {
  return `${useAppStore().baseUrl}${process.env.VUE_APP_API_CHECK_WIDGET_CLIENT}`;
});

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_spinner, {
        size: 50,
        color: "#009D3E"
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("iframe", {
        src: widgetUrl.value,
        class: "widget__content"
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})